export default __webpack_public_path__ + "static/media/img_401.dc6ed40d.svg";